import { jsx as t } from "react/jsx-runtime";
import { Alert as e } from "flowbite-react";
import { theme as m } from "./theme.js";
const o = (r) => /* @__PURE__ */ t(e, { ...r, theme: m });
o.displayName = "Alert";
export {
  o as Alert,
  o as default
};
